import PropTypes from "prop-types";
import { t } from "@/i18n-js/instance";
import { isDraftSpace } from "@circle-react/helpers/spaceHelpers";

export const CourseCardBadge = ({ course }) => {
  const { is_new: isNew } = course;
  const isDraft = isDraftSpace(course);

  if (isDraft) {
    return (
      <span className="bg-badge text-xxs text-badge absolute left-2 top-2 z-10 rounded px-2 py-0.5 font-bold uppercase">
        {t("courses.directory.card.draft")}
      </span>
    );
  }

  if (isNew) {
    return (
      <span className="text-xxs text-badge bg-c-sidebar-badge absolute left-2 top-2 z-10 rounded px-2 py-0.5 font-bold uppercase">
        {t("courses.directory.card.new")}
      </span>
    );
  }

  return null;
};

CourseCardBadge.propTypes = {
  course: PropTypes.shape({
    is_new: PropTypes.bool,
    visibility: PropTypes.string,
  }).isRequired,
};
